import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const vamoConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Vamo Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Vamo, FL. Sam\'s Tree Service tackles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_vamo',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Vamo',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Vamo Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care right to your door 
     in <strong>Vamo</strong>. Sitting between Sarasota Bay and the Gulf Coast, this 
     community sees its share of wind, salt air, and storm activity all of which take 
     a toll on trees over time. When limbs start threatening your home, carport, or 
     power lines, our team responds quickly with the skill and equipment to handle it right.`,

    `We specialize in <strong>hazardous tree removal and precision trimming</strong>
     including salt damaged canopies, wind stressed palms, overgrown limbs near structures, 
     and trees weakened by Florida's wet season. No job is too complex or too urgent 
     for our experienced crew.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Vamo</strong> and the surrounding <strong>South Sarasota</strong> 
     waterfront communities so your property stays safe, clean, and protected all year long.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Vamo, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Vamo = () => <LocationPage config={vamoConfig} />;
export default Services_Vamo;
